import { render, staticRenderFns } from "./Xy.vue?vue&type=template&id=e73c43c8&scoped=true&"
var script = {}
import style0 from "./Xy.vue?vue&type=style&index=0&id=e73c43c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e73c43c8",
  null
  
)

export default component.exports